import CalendarAttachment from './CalendarAttachment';

export default CalendarAttachment;
